/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiSessionsGet } from '../fn/sessions/api-sessions-get';
import { ApiSessionsGet$Params } from '../fn/sessions/api-sessions-get';
import { apiSessionsInviteOperatorPost } from '../fn/sessions/api-sessions-invite-operator-post';
import { ApiSessionsInviteOperatorPost$Params } from '../fn/sessions/api-sessions-invite-operator-post';
import { apiSessionsSessionIdGet } from '../fn/sessions/api-sessions-session-id-get';
import { ApiSessionsSessionIdGet$Params } from '../fn/sessions/api-sessions-session-id-get';
import { apiSessionsSessionIdObserverTokenGet } from '../fn/sessions/api-sessions-session-id-observer-token-get';
import { ApiSessionsSessionIdObserverTokenGet$Params } from '../fn/sessions/api-sessions-session-id-observer-token-get';
import { apiSessionsSessionIdTranscriptGet } from '../fn/sessions/api-sessions-session-id-transcript-get';
import { ApiSessionsSessionIdTranscriptGet$Params } from '../fn/sessions/api-sessions-session-id-transcript-get';
import { apiSessionsTransferAgentsTransferRuleIndexDispatchGet } from '../fn/sessions/api-sessions-transfer-agents-transfer-rule-index-dispatch-get';
import { ApiSessionsTransferAgentsTransferRuleIndexDispatchGet$Params } from '../fn/sessions/api-sessions-transfer-agents-transfer-rule-index-dispatch-get';
import { DispatchAgentResult } from '../models/dispatch-agent-result';
import { GetAgentSessionHistoryResult } from '../models/get-agent-session-history-result';
import { GetAgentSessionsResult } from '../models/get-agent-sessions-result';
import { GetObserverTokenResult } from '../models/get-observer-token-result';
import { GetSessionTranscriptResult } from '../models/get-session-transcript-result';
import { InviteOperatorCommandResult } from '../models/invite-operator-command-result';


/**
 * Everything addressed by a session: reading one, listening in on it, and the
 * two transfer endpoints the worker calls mid-call.
 *             
 *
 * The session arrives two ways, and the split is deliberate. Endpoints a UI
 * calls take it in the route. Endpoints the WORKER calls take it from the
 * `X-Session-Id` header, because the worker's tool executor already sends
 * that header on every tool call — so a tool has nothing to assemble. Being a
 * header changes nothing about trust: it is client-supplied either way, and
 * what protects the session is the ownership check each handler performs
 * against the token.
 */
@Injectable({ providedIn: 'root' })
export class SessionsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSessionsGet()` */
  static readonly ApiSessionsGetPath = '/api/Sessions';

  /**
   * Sessions list, cursor-paginated. All filters are optional.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSessionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSessionsGet$Response(params?: ApiSessionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentSessionsResult>> {
    const obs = apiSessionsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sessions list, cursor-paginated. All filters are optional.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSessionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSessionsGet(params?: ApiSessionsGet$Params, context?: HttpContext): Observable<GetAgentSessionsResult> {
    const resp = this.apiSessionsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetAgentSessionsResult>): GetAgentSessionsResult => r.body)
    );
  }

  /** Path part for operation `apiSessionsSessionIdGet()` */
  static readonly ApiSessionsSessionIdGetPath = '/api/Sessions/{sessionId}';

  /**
   * One session with its chat history and audio links.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSessionsSessionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSessionsSessionIdGet$Response(params: ApiSessionsSessionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentSessionHistoryResult>> {
    const obs = apiSessionsSessionIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * One session with its chat history and audio links.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSessionsSessionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSessionsSessionIdGet(params: ApiSessionsSessionIdGet$Params, context?: HttpContext): Observable<GetAgentSessionHistoryResult> {
    const resp = this.apiSessionsSessionIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetAgentSessionHistoryResult>): GetAgentSessionHistoryResult => r.body)
    );
  }

  /** Path part for operation `apiSessionsSessionIdTranscriptGet()` */
  static readonly ApiSessionsSessionIdTranscriptGetPath = '/api/Sessions/{sessionId}/transcript';

  /**
   * One conversation as a readable transcript: who said what, in order, plus the
   * tool calls the agent made along the way.
   *             
   *
   * Deliberately not the full session card (`GetSessionHistory`): that one
   * carries per-message metrics, model references and presigned audio links.
   * Readers — the in-app agent above all — pull a dozen conversations at a time
   * to judge how an agent behaves, and drown in the rest of it.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSessionsSessionIdTranscriptGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSessionsSessionIdTranscriptGet$Response(params: ApiSessionsSessionIdTranscriptGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSessionTranscriptResult>> {
    const obs = apiSessionsSessionIdTranscriptGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * One conversation as a readable transcript: who said what, in order, plus the
   * tool calls the agent made along the way.
   *             
   *
   * Deliberately not the full session card (`GetSessionHistory`): that one
   * carries per-message metrics, model references and presigned audio links.
   * Readers — the in-app agent above all — pull a dozen conversations at a time
   * to judge how an agent behaves, and drown in the rest of it.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSessionsSessionIdTranscriptGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSessionsSessionIdTranscriptGet(params: ApiSessionsSessionIdTranscriptGet$Params, context?: HttpContext): Observable<GetSessionTranscriptResult> {
    const resp = this.apiSessionsSessionIdTranscriptGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetSessionTranscriptResult>): GetSessionTranscriptResult => r.body)
    );
  }

  /** Path part for operation `apiSessionsSessionIdObserverTokenGet()` */
  static readonly ApiSessionsSessionIdObserverTokenGetPath = '/api/Sessions/{sessionId}/observer-token';

  /**
   * Issue an observer LiveKit token for an active session — joiner subscribes to
   * tracks but cannot publish (canPublish=false, hidden=true). Lets an admin
   * "listen in" without affecting the call. Session must be Active; 30-min TTL.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSessionsSessionIdObserverTokenGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSessionsSessionIdObserverTokenGet$Response(params: ApiSessionsSessionIdObserverTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetObserverTokenResult>> {
    const obs = apiSessionsSessionIdObserverTokenGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Issue an observer LiveKit token for an active session — joiner subscribes to
   * tracks but cannot publish (canPublish=false, hidden=true). Lets an admin
   * "listen in" without affecting the call. Session must be Active; 30-min TTL.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSessionsSessionIdObserverTokenGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSessionsSessionIdObserverTokenGet(params: ApiSessionsSessionIdObserverTokenGet$Params, context?: HttpContext): Observable<GetObserverTokenResult> {
    const resp = this.apiSessionsSessionIdObserverTokenGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetObserverTokenResult>): GetObserverTokenResult => r.body)
    );
  }

  /** Path part for operation `apiSessionsInviteOperatorPost()` */
  static readonly ApiSessionsInviteOperatorPostPath = '/api/Sessions/invite-operator';

  /**
   * Invite a live operator into an ongoing conversation — transfer to a
   * human (SKN-308). Called by the worker once the agent decided to
   * transfer.
   *             
   *
   * Does NOT wait for the operator to answer — it returns as soon as the
   * provider accepted the request. The worker sees the pickup itself: the
   * participant shows up in the very room it sits in, carrying the role
   * attribute. Failure to reach the operator is reported by the backend
   * through room metadata, because "the participant never arrived" has
   * nothing to observe.
   *
   * The role alone is not enough: the handler also verifies that the session
   * belongs to the caller, and that the requested rule is an
   * operator-transfer rule of that same agent.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSessionsInviteOperatorPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSessionsInviteOperatorPost$Response(params?: ApiSessionsInviteOperatorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<InviteOperatorCommandResult>> {
    const obs = apiSessionsInviteOperatorPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Invite a live operator into an ongoing conversation — transfer to a
   * human (SKN-308). Called by the worker once the agent decided to
   * transfer.
   *             
   *
   * Does NOT wait for the operator to answer — it returns as soon as the
   * provider accepted the request. The worker sees the pickup itself: the
   * participant shows up in the very room it sits in, carrying the role
   * attribute. Failure to reach the operator is reported by the backend
   * through room metadata, because "the participant never arrived" has
   * nothing to observe.
   *
   * The role alone is not enough: the handler also verifies that the session
   * belongs to the caller, and that the requested rule is an
   * operator-transfer rule of that same agent.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSessionsInviteOperatorPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSessionsInviteOperatorPost(params?: ApiSessionsInviteOperatorPost$Params, context?: HttpContext): Observable<InviteOperatorCommandResult> {
    const resp = this.apiSessionsInviteOperatorPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InviteOperatorCommandResult>): InviteOperatorCommandResult => r.body)
    );
  }

  /** Path part for operation `apiSessionsTransferAgentsTransferRuleIndexDispatchGet()` */
  static readonly ApiSessionsTransferAgentsTransferRuleIndexDispatchGetPath = '/api/Sessions/transfer-agents/{transferRuleIndex}/dispatch';

  /**
   * Configuration of the agent to transfer the conversation to, picked by
   * rule INDEX rather than by id — a model can plausibly get a GUID wrong,
   * and a flipped character still looks like a valid one.
   *
   * Returns the same shape as an ordinary dispatch, assembled in test mode:
   * nothing is sent to LiveKit, because the room already has an agent and the
   * swap is the worker's job. The session is reused, so the transfer does not
   * spawn a second conversation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSessionsTransferAgentsTransferRuleIndexDispatchGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSessionsTransferAgentsTransferRuleIndexDispatchGet$Response(params: ApiSessionsTransferAgentsTransferRuleIndexDispatchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DispatchAgentResult>> {
    const obs = apiSessionsTransferAgentsTransferRuleIndexDispatchGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Configuration of the agent to transfer the conversation to, picked by
   * rule INDEX rather than by id — a model can plausibly get a GUID wrong,
   * and a flipped character still looks like a valid one.
   *
   * Returns the same shape as an ordinary dispatch, assembled in test mode:
   * nothing is sent to LiveKit, because the room already has an agent and the
   * swap is the worker's job. The session is reused, so the transfer does not
   * spawn a second conversation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSessionsTransferAgentsTransferRuleIndexDispatchGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSessionsTransferAgentsTransferRuleIndexDispatchGet(params: ApiSessionsTransferAgentsTransferRuleIndexDispatchGet$Params, context?: HttpContext): Observable<DispatchAgentResult> {
    const resp = this.apiSessionsTransferAgentsTransferRuleIndexDispatchGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DispatchAgentResult>): DispatchAgentResult => r.body)
    );
  }

}
